<template>
  <svg :width="width" :height="height">
    <path d="M8 14 1.333 2.667h13.334z" :fill="color" fill-rule="evenodd" />
  </svg>
</template>
<script>
import { HIGHLIGHT_COLOR } from '@/constants/style';
export default {
  name: 'Triangle',
  props: {
    width: {
      type: String,
      default: '16'
    },
    height: {
      type: String,
      default: '16'
    },
    color: {
      type: String,
      default: HIGHLIGHT_COLOR
    }
  }
};
</script>

<style></style>
